import { CLEAR_DELEGATIONS_IN_PROGRESS } from "../../../../enums/MyDivision/Delegation/AuthorityRevocation";

export const clearActiveDelegations = () => {
    return {
        type: CLEAR_DELEGATIONS_IN_PROGRESS,
    }
}
